<!--
 * @Author: DY
 * @Date: 2025-02-17 16:49:33
 * @LastEditTime: 2025-02-21 17:08:11
 * @Description: 超期解锁申请表单【技术质量管理-超期解锁】
 * @FilePath: \ShiMo_Mobile\src\views\technicalQualityManagement\overdueUnlockApplication\form.vue
-->
<template>
    <v-touch @swiperight="closeAllocationForm" class="wrapper">
        <div class="overdueUnlockApplicationForm commonFormStyles">
            <HeaderNav header-title="超期解锁申请" left-icon-name="2" right-icon-name="3" :extr="{ leftCallBack: closeAllocationForm }"></HeaderNav>
            <van-tabs class="currencyTabsStyle" v-model="tabActive">
                <van-tab title="基本信息" name="1">
                    <div class="formList">
                        <ul class="formItem">
                            <li class="formItemTitle">
                                <h5>申请信息表</h5>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="超期解锁申请编号"
                                    placeholder="自动生成"
                                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                    v-model="formData.BatchNumber"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="申请人"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.ApplyUserName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="申请部门"
                                    :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                    v-model="formData.ApplyDeptName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    readonly
                                    label="仓库编码"
                                    :disabled="isDisabled"
                                    placeholder="请选择仓库"
                                    :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    v-model="formData.StockCode"
                                    @click="selectStock"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="仓库名称"
                                    placeholder="请选择仓库"
                                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                                    v-model="formData.StockName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    readonly
                                    label="库位编码"
                                    placeholder="请选择库位"
                                    :disabled="isDisabled"
                                    :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    v-model="formData.GridCode"
                                    @click="selectGrid"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="库位名称"
                                    placeholder="请选择库位"
                                    :left-icon="require('@/assets/images/icons/icon_44@2x.png')"
                                    v-model="formData.GridName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    readonly
                                    label="物料代码"
                                    placeholder="请选择物料"
                                    :disabled="isDisabled"
                                    :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                                    v-model="formData.MaterialCode"
                                    @click="selectMaterial"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="物料短描述"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                    v-model="formData.MaterialShortName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    label="申请解锁产品卡数量"
                                    placeholder="请输入数量"
                                    :disabled="isDisabled"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.ApplyCount"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    label="申请说明"
                                    placeholder="请输入申请说明"
                                    :disabled="isDisabled"
                                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                    type="textarea"
                                    v-model="formData.ApplyRemark"
                                    :rows="3"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="审核人"
                                    :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                                    v-model="formData.CheckName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="审核部门"
                                    :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                                    v-model="formData.CheckDeptName"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="解锁产品卡数量"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.CheckCount"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="解锁说明"
                                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                    type="textarea"
                                    v-model="formData.CheckRemark"
                                    :rows="3"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="制单时间"
                                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                    v-model="formData.CreationTime"
                                ></van-field>
                            </li>
                            <li>
                                <van-field
                                    disabled
                                    label="状态"
                                    :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                                    v-model="Status"
                                ></van-field>
                            </li>
                        </ul>
                    </div>
                </van-tab>
                <van-tab title="产品明细" name="2">
                    <div class="formList">
                        <ul class="formItem">
                            <li class="formItemTitle">
                                <h5>产品明细表</h5>
                                <van-icon name="add" v-if="!isDisabled" @click="selectCards"></van-icon>
                            </li>
                            <dl class="materialList" v-for="(item, index) in formData.Cards" :key="`material_${index}`">
                                <dt>
                                    <van-icon name="clear" v-if="!isDisabled" @click="deleteMaterial(index)"></van-icon>
                                    <h5>生产批号</h5>
                                    <p>{{ item.ProductCardNumber }}</p>
                                </dt>
                                <dd>
                                    <div>
                                        <p>物料代码：</p>
                                        <input type="text" disabled v-model="item.MaterialCode">
                                    </div>
                                    <div>
                                        <p>短描述：</p>
                                        <input type="text" disabled v-model="item.MaterialShortName">
                                    </div>
                                    <div>
                                        <p>单包重量：</p>
                                        <input type="number" v-model="item.PackageSingleWeight" :disabled="isDisabled">
                                    </div>
                                    <div>
                                        <p>生产天数：</p>
                                        <input type="text" disabled v-model="item.ProductDay">
                                    </div>
                                </dd>
                            </dl>
                        </ul>
                    </div>
                </van-tab>
            </van-tabs>
            <footer class="currencyFooterStyle btns">
                <template v-if="!isDisabled">
                    <van-button type="primary" loading-type="spinner" @click="sbmitForm">
                        提交
                    </van-button>
                    <van-button type="primary" loading-type="spinner" @click="saveForm">
                        保存
                    </van-button>
                </template>
                <van-button v-else type="primary" loading-type="spinner" @click="closeAllocationForm">
                    关闭
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import currencyFun from '@/assets/js/currencyFun/index.js';
export default {
    name: 'overdue-unlock-application-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/overdueUnlockApplication') {
            this.$store.commit('noKeepAlive', 'overdue-unlock-application-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isRefresh: false,
            tabActive: 0,
            isDisabled: false,
            Status: '',
            formData: {
                Id: '',
                BatchNumber: '',
                ApplyUserId: '',
                ApplyUserName: '',
                ApplyDeptId: '',
                ApplyDeptName: '',
                ApplyCount: 0,
                ApplyRemark: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                GridId: '',
                GridCode: '',
                GridName: '',
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
                CheckId: '',
                CheckName: '',
                CheckTime: '',
                CheckDeptId: '',
                CheckDeptName: '',
                CheckCount: 0,
                CheckRemark: '',
                Status: 0,
                AutoIndex: 0,
                YearIndex: '',
                CreationTime: '',
                Cards: [],
            },
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.Stock) {
            this.formData.StockId = this.$route.params.Stock[0].id;
            this.formData.StockCode = this.$route.params.Stock[0].stock_code;
            this.formData.StockName = this.$route.params.Stock[0].stock_name;

            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';

            this.formData.MaterialCode = '';
            this.formData.MaterialName = '';
            this.formData.MaterialShortName = '';
        }
        if (this.$route.params.Grid) {
            this.formData.GridId = this.$route.params.Grid[0].grid_id;
            this.formData.GridCode = this.$route.params.Grid[0].grid_code;
            this.formData.GridName = this.$route.params.Grid[0].grid_name;

            this.formData.MaterialCode = '';
            this.formData.MaterialName = '';
            this.formData.MaterialShortName = '';
        }
        if (this.$route.params.Material) {
            this.formData.MaterialCode = this.$route.params.Material[0].material_code;
            this.formData.MaterialName = this.$route.params.Material[0].material_name;
            this.formData.MaterialShortName = this.$route.params.Material[0].material_short_name;
        }
        if (this.$route.params.Cards) {
            (this.$route.params.Cards || []).forEach(item => {
                this.formData.Cards.push({
                    ProductCardId: item.id,
                    ProductCardNumber: item.product_card_number,
                    ProductDate: item.product_date,
                    PackageSingleWeight: item.package_single_weight,
                    MaterialCode: item.material_code,
                    MaterialName: item.material_name,
                    MaterialShortName: item.material_short_name,
                    ProductDay: item.product_day,
                });
            });
            this.loadCheckCount();
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'overdueUnlockApplication',
                params: {
                    isRefresh: this.isRefresh,
                },
            });
        },
        async initpage() {
            if (this.$route.params.type === 'add') {
                this.formData.ApplyDeptName = this.$takeTokenParameters('DeptName');
                this.formData.ApplyDeptId = this.$takeTokenParameters('DeptId');
                this.formData.CreationTime = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
                this.formData.ApplyUserName = this.$takeTokenParameters('Name');
                this.formData.ApplyUserId = this.$takeTokenParameters('Uid');
            } else {
                this.formData = await this.getformDataRequrst(this.$route.params.id);
            }
            if (this.$route.params.type === 'view') {
                this.isDisabled = true;
            }
            this.Status = this.loadStatus(this.formData.Status);
        },
        loadStatus(nub) {
            const staus = ['未提交', '已提交', '已退回', '已确认'];
            return staus[nub];
        },
        // 选择仓库
        selectStock() {
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'overdueUnlockApplicationForm',
                    listCode: 'transition_select_stock',
                    callbackDataKey: 'Stock',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '仓库编号',
                        code: 'stock_code',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'stock_name',
                        icon: 'icon_47@2x',
                    }, {
                        name: '位置',
                        code: 'stock_location',
                        icon: 'icon_3@2x',
                    }, {
                        name: '规格',
                        code: 'stock_spec',
                        icon: 'icon_5@2x',
                    }, {
                        name: '保管员',
                        code: 'storeman_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '保管员电话',
                        code: 'storeman_phone',
                        icon: 'icon_9@2x',
                    }],
                },
            });
        },

        // 选择库位
        selectGrid() {
            if (this.isDisabled) { return; }
            if ((this.formData.StockId || '') === '') {
                this.$toast.fail('请先选择仓库！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    newsToken: this.newsToken,
                    pageTitle: '选择库位',
                    sourcePath: 'overdueUnlockApplicationForm',
                    listCode: 'transition_select_grid',
                    callbackDataKey: 'Grid',
                    requestUrl: `/basicplatform/tabledata?stock_id=${this.formData.StockId}`,
                    relationKey: 'grid_id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '库位编号',
                        code: 'grid_code',
                        isTitle: true,
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_44@2x',
                    }],
                },
            });
        },
        // 选择物料代码
        selectMaterial() {
            if (this.isDisabled) { return; }
            if ((this.formData.GridId || '') === '') {
                this.$toast.fail('请先选择库位！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    newsToken: this.newsToken,
                    pageTitle: '选择转换前物料代码',
                    sourcePath: 'overdueUnlockApplicationForm',
                    listCode: 'overdue_select_material',
                    callbackDataKey: 'Material',
                    requestUrl: `/basicplatform/tabledata?type=${this.formData.Type}&grid_id=${this.formData.GridId}`,
                    relationKey: 'material_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '物料编码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '物料名称',
                        code: 'material_name',
                        icon: 'icon_1@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '单位',
                        code: 'unit',
                        icon: 'icon_24@2x',
                    }],
                },
            });
        },
        selectCards() {
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择产品卡',
                    sourcePath: 'overdueUnlockApplicationForm',
                    requestUrl: `/basicplatform/tabledata?material_code=${this.formData.MaterialCode}&grid_id=${this.formData.GridId}`,
                    listCode: 'overdue_select_product_card',
                    callbackDataKey: 'Cards',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    type: 'checkbox',
                    pageSize: 100,
                    showTotal: true,
                    totalKey: 'package_single_weight',
                    headerList: [{
                        name: '产品卡号',
                        code: 'product_card_number',
                        isTitle: true,
                    }, {
                        name: '物料代码',
                        code: 'material_code',
                        icon: 'icon_46@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '生产部门',
                        code: 'product_workshop_name',
                        icon: 'icon_45@2x',
                    }, {
                        name: '生产日期',
                        code: 'product_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '单包重量（吨）',
                        code: 'package_single_weight',
                        icon: 'icon_16@2x',
                    }, {
                        name: '生产天数',
                        code: 'product_day',
                        icon: 'icon_36@2x',
                    }],
                },
            });
        },
        deleteMaterial(index) {
            this.formData.Cards.splice(index, 1);
            this.loadCheckCount();
        },

        loadCheckCount() {
            this.formData.ApplyCount = this.formData.Cards.reduce((total, item) => {
                return total + (item.PackageSingleWeight ? parseFloat(item.PackageSingleWeight) : 0);
            }, 0);
        },
        async saveForm() {
            const res = await this.saveformDataRequrst(this.formData);
            if (res) {
                this.formData = res;
                this.isRefresh = true;
                this.$toast.success('保存成功。');
            }
        },
        async sbmitForm() {
            if ((this.formData.Id || '') === '') {
                this.$toast.fail('请先保存！');
            }
            const res = await this.sbmitFormRequrst(this.formData.Id);
            if (res) {
                this.$toast.success('提交成功。');
                this.isRefresh = true;
                this.closeAllocationForm();
            }
        },
        getformDataRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/product_card_overdue/info/${id}`);
        },
        saveformDataRequrst(requestData) {
            return this.$axios.$post('interfaceApi/sale/product_card_overdue/save', requestData);
        },
        sbmitFormRequrst(id) {
            return this.$axios.$post(`/interfaceApi/sale/product_card_overdue/submit/${id}`);

        },
    },
};
</script>
<style lang="stylus">
.overdueUnlockApplicationForm
    background: #f0f0f0;
    .currencyTabsStyle
        height 0
        flex 1
    .formList
        padding 10rpx
        &.formList_Readonly
            height calc(100% - 44rpx)
        .materialList
            margin 10rpx
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
            border-radius: 4rpx;
            overflow hidden
            dt
                height 42rpx
                background: #F8F8F8;
                border-bottom: 1px solid #E7E6E6;
                display flex
                align-items center
                padding 0 14rpx
                .van-icon
                    color #E93543
                    font-size 16rpx
                    margin-right 10rpx
                h5
                    font-size 16rpx
                    color #e93743
                p
                    margin-left auto
                    color #e93743
            dd
                padding 7rpx
                display flex
                flex-wrap wrap
                div
                    width 50%
                    padding 7rpx
                    p
                        font-size 14rpx
                        color #626262
                        margin-bottom 6rpx
                    input
                        width 100%
                        height: 40px;
                        padding 0 6rpx
                        background: #FAFBFE;
                        border-radius: 4px;
                        border: 1px solid #ADC7E0;
                        &[disabled]
                            background: #F8F8F8
                            border-color #D7D7D7
                            color rgba(98, 98, 98, 0.7)
                            -webkit-text-fill-color rgba(98, 98, 98, 0.7)
</style>
